import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Analytics } from "../../js/Analytics";

const DealsCardItem = ({ dataItem, restUrl }) => {
    const {
        name,
        small_image,
        has_image,
        sku,
        featured_type,
        featured_type_varchar,
        description,
        seller_id,
        seller_name
    } = dataItem;

    let image_src = (has_image !== "No") ? `${restUrl}/pub/media/catalog/product/${small_image}` : "https://www.labx.com/images/image-not-found.png";
    let cardType = (featured_type == 16306 || featured_type_varchar == 16306) ? "free" : "paid";
    let body = description.replace(/<\/?[^>]+(>|$)/g, "");
    let length_limit = (cardType === "free") ? 100 : 130;

    if (body.length > length_limit)
        body = `${body.substring(0, length_limit)}...`;

    const event_properties = {
        action: "Deal_" + name,
        label: `${window.location.origin}/item/${sku}`,
        value: sku, // NOTE(trevor) Most banners use io_number instead
        seller: {
            id: seller_id,
            name: seller_name
        }
    };

    useEffect(() => {
        Analytics.view(event_properties);
    }, []);

    const handleCTAClick = () => {
        Analytics.click(event_properties);
    };

    return (
        <div className={ (cardType === "free") ? "card-free" : "card-new" }>
            <div>
                { cardType !== "free" &&
                    <div className="card-img-top card-image">
                        <img src={image_src} alt={name} loading="lazy" />
                    </div>
                }
                <ul className="deals-ul">
                    <div className="card-main">
                        <li><strong><h2 className="title h2-style">{name}</h2></strong></li>
                        <li>{body}</li>
                        <li className="li-view-details">
                            <a
                                onClick={handleCTAClick}
                                href={`/item/${sku}`}
                                className="btn btn-lx-secondary btn-view-details"
                                rel="noopener"
                            >
                                VIEW DETAILS
                            </a>
                        </li>
                    </div>
                </ul>
            </div>
        </div>
    );
};

DealsCardItem.defaultProps = {
    dataItem: {},
    restUrl: ""
};

DealsCardItem.propTypes = {
    dataItem: PropTypes.object,
    restUrl: PropTypes.string
};

export default DealsCardItem;
